module.exports = __webpack_public_path__ + "img/cb9-l-111.faf184ca.gif";